<script lang="ts">
  import { defineComponent } from "vue";
  import FicheStatClient from '@/generated/fiches/FicheStatClient.vue';
  export default defineComponent({
    extends: FicheStatClient,
    components: {}
})
</script>
